import React, { useContext } from 'react'
import { EventAgendaContext } from '@/component/Context/EventAgendaContext'
import scssStyles from './ProgramItem.module.scss'
import {
  ProgramBox,
  ProgramContent,
  ProgramFlex,
  ProgramStack,
  ProgramTitle,
  ProgramText,
  useProgram
} from 'planby'
import { object } from 'prop-types'
import cx from 'classnames'

export const ProgramItem = ({ program, ...rest }) => {
  const { handleOpenModal, setEventAgendaModalItem } = useContext(
    EventAgendaContext
  )
  const { styles, isLive } = useProgram({
    program,
    ...rest
  })

  const { data } = program
  const { name, speakers } = data

  const formatSpeakers = (speakers) => {
    return speakers.map((speaker) => speaker?.name).join(', ')
  }

  const handleClick = () => {
    setEventAgendaModalItem({ ...data })
    handleOpenModal()
  }

  return (
    <ProgramBox
      width={styles.width}
      style={styles.position}
      className={scssStyles.ProgamBox}
      onClick={() => handleClick()}
    >
      <ProgramContent
        width={styles.width}
        isLive={isLive}
        className={cx(scssStyles.ProgramContent, isLive && scssStyles.live)}
      >
        <ProgramFlex>
          <ProgramStack>
            <ProgramTitle className={scssStyles.ProgramTitle}>
              {name}
            </ProgramTitle>
            {!!speakers.length && (
              <ProgramText className={scssStyles.ProgramText}>
                {formatSpeakers(speakers)}
              </ProgramText>
            )}
          </ProgramStack>
        </ProgramFlex>
      </ProgramContent>
    </ProgramBox>
  )
}

ProgramItem.propTypes = {
  program: object
}
